import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { api, apiErr } from "../../api/client";
import { useAuth } from "../../contexts/AuthContext";
import { FORCE_CHANGE } from "../../constants/testIds";
import { toast } from "sonner";

export function ForceChangeDialog() {
    const { refreshMe, user } = useAuth();
    const [current, setCurrent] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPin, setNewPin] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const requirePassword = user?.role === "admin" || user?.role === "office";
    const currentLabel = "Current PIN or password";

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        try {
            const body = { current_secret: current };
            if (newPassword) body.new_password = newPassword;
            if (newPin) body.new_pin = newPin;
            await api.post("/auth/force-change", body);
            toast.success("Credentials updated");
            await refreshMe();
        } catch (e) {
            setErr(apiErr(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open>
            <DialogContent
                data-testid={FORCE_CHANGE.dialog}
                className="sm:max-w-md"
                onEscapeKeyDown={(e) => e.preventDefault()}
                onInteractOutside={(e) => e.preventDefault()}
            >
                <DialogHeader>
                    <DialogTitle className="font-extrabold tracking-[-0.03em] text-2xl">
                        Set your credentials
                    </DialogTitle>
                    <DialogDescription>
                        First login — please replace the default {requirePassword ? "password" : "PIN"}.
                    </DialogDescription>
                </DialogHeader>
                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <Label>{currentLabel}</Label>
                        <Input
                            data-testid={FORCE_CHANGE.current}
                            type="password"
                            value={current}
                            onChange={(e) => setCurrent(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>
                    {requirePassword ? (
                        <div>
                            <Label>New password (min 8 chars)</Label>
                            <Input
                                data-testid={FORCE_CHANGE.newPassword}
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                                minLength={8}
                            />
                        </div>
                    ) : (
                        <div>
                            <Label>New PIN (4 digits, not 0000)</Label>
                            <Input
                                data-testid={FORCE_CHANGE.newPin}
                                type="text"
                                inputMode="numeric"
                                maxLength={4}
                                value={newPin}
                                onChange={(e) => setNewPin(e.target.value.replace(/\D/g, "").slice(0, 4))}
                                required
                                className="num text-center text-xl tracking-[0.4em]"
                            />
                        </div>
                    )}
                    {err && (
                        <div data-testid={FORCE_CHANGE.error} className="text-sm text-[color:var(--km-danger)]">
                            {err}
                        </div>
                    )}
                    <Button data-testid={FORCE_CHANGE.submit} type="submit" disabled={busy} className="w-full">
                        {busy ? "Saving…" : "Save & continue"}
                    </Button>
                </form>
            </DialogContent>
        </Dialog>
    );
}
